(function () {

  const product_slider_v1_list = document.querySelectorAll('.js_product_slider_v1')

  for (let i = 0; i < product_slider_v1_list.length; i++) {
    const slider = product_slider_v1_list[i]
    initProductSliderV1(slider)
  }

  function initProductSliderV1 (slider) {
    const sliderWrapEl = slider.closest('.product-slider-sec')
    const swiperPagination = sliderWrapEl.querySelector('.swiper-pagination')
    const swiperButtonNext = sliderWrapEl.querySelector('.swiper-button-next')
    const swiperButtonPrev = sliderWrapEl.querySelector('.swiper-button-prev')

    let sliderOptions = {
      spaceBetween: 40,
      slidesPerView: 1,
      // centeredSlides: true,
      loop: true,
      // Responsive breakpoints
      breakpoints: {
        // when window width is >= 768px
        767: {
          // centeredSlides: false,
          slidesPerView: 2,
          spaceBetween: 20
        },
        // when window width is >= 1200px
        1200: {
          // centeredSlides: true,
          slidesPerView: 3,
          spaceBetween: 40
        }
      },
      pagination: {
        el: ".js_product_slider_v1_pagination .swiper-pagination",
        clickable: true,
        dynamicBullets: false,
      },
      navigation: {
        nextEl: ".js_product_slider_v1_nav .swiper-button-next",
        prevEl: ".js_product_slider_v1_nav .swiper-button-prev",
      },
    }

    // Override from theme
    // if (window.productSliderV1Override) {
    //   sliderOptions = window.productSliderV1Override(slider)
    // }

    new Swiper(slider, sliderOptions)
  }

})()
